import { Breadcrumb } from '@interfaces/models/breadcrumb';
import Breadcrumbs from '@components/molecules/products/breadcrumbs/breadcrumbs';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';
import { CampaignContext } from '@context/campaign.context';
import useGuidedSearchQuery from '@hooks/catalog-context/use-guided-search-query';
import useWindowSize from '@hooks/use-window-size';
import { useRouter } from 'next/router';
import { isPersonalizedNewInsPage } from '@helpers/routing';
import dynamic from 'next/dynamic';
import CampaignHeader from '../campaign/campaign-header';
import styles from './catalog-header.module.scss';

const CatalogHeaderNavigation = dynamic(
  () => import('@components/catalog/catalog-header-navigation/catalog-header-navigation'),
);

export type CatalogHeaderProps = {
  title: string;
  breadcrumbs: Breadcrumb[];
  customClassName?: string;
} & React.HTMLProps<HTMLDivElement>;

const CatalogHeader: React.FC<CatalogHeaderProps> = (props) => {
  const { title, breadcrumbs, customClassName } = props;

  const campaign = useContextSelector(CampaignContext, (v) => v.campaign);
  const { isWiderThanMd } = useWindowSize();
  const { asPath } = useRouter();

  const { showCarousel } = useGuidedSearchQuery();
  const showBreadcrumb = useMemo(() => {
    if (isPersonalizedNewInsPage(asPath)) {
      return false;
    }
    return true;
  }, [isWiderThanMd]);

  return (
    <div
      className={clsx(styles.catalogHeader, showCarousel && styles['catalogHeader--withNavigation'], customClassName)}
    >
      <div className={styles.catalogHeader__mainHeading}>
        {breadcrumbs && showBreadcrumb && (
          <div className={clsx(styles.productPage__top__breadcrumb, 'd-md-block')}>
            <Breadcrumbs
              breadcrumbs={breadcrumbs}
              isCatalogPage
            />
          </div>
        )}
        {campaign && <CampaignHeader {...campaign} />}
        {!campaign && (
          <>
            <>
              <span className={clsx(styles.catalogHeader__mainTitle, 'vc-title-m')}>{title}</span>
              {showCarousel && <CatalogHeaderNavigation />}
            </>
          </>
        )}
      </div>
    </div>
  );
};

export default CatalogHeader;
